module.exports = __webpack_public_path__ + "static/media/BA671111.c311e146.jpg";